<button class="font-body3" [ngClass]="{ 'blue' : blue, 'secondary' : secondary }" [disabled]="disabled">{{text}}</button>
